import { AfterViewInit, Component, DestroyRef, OnInit, QueryList, ViewChild, ViewChildren, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationExtras, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { MultiSelect, MultiSelectChangeEvent } from 'primeng/multiselect';
import { CountryName } from '../../../../assets/functions/get-country-name';
import { SearchByPriceName } from '../../../../assets/functions/get-price-name';
import { OnlyAcceptNumbers } from '../../../../assets/functions/only-accept-numbers';
import { ConstantsFordProtect } from '../../../models/constants/constants-ford-protect';
import { ViewPlans } from '../../../models/enum/view-plans';
import { NewPlansApplication } from '../../../models/interface/common/new-plans.application';
import { CoverageCategoryOws } from '../../../models/product/coverage-category-ows';
import { PriceDto } from '../../../models/product/price-dto';
import { PriceSearchCriteria } from '../../../models/product/price-search-criteria';
import { ProductPolicy } from '../../../models/product/product-policy';
import { ProductVisit } from '../../../models/product/product-visit';
import { CoverageService } from '../../../services/coverage/coverage.service';
import { PriceService } from '../../../services/price/price.service';
import { ProductPolicyService } from '../../../services/product-policy/product-policy.service';
import { ProductService } from '../../../services/product/product.service';
import { SystemCountryService } from '../../../services/system-country/system-country.service';

type PlanItem = ProductVisit | CoverageCategoryOws | PriceDto | ProductPolicy;

interface ViewPlansFilters {
  selectTypePlan: string;
  selectedCountries: string[];
  selectedCurrencies: string[];
  selectedPriceTypes: string[];
}

interface ViewPlansSnapshot extends ViewPlansFilters {
  products: PlanItem[];
  selectedProducts: PlanItem[];
  selectedProductsResult: PlanItem[];
}

@Component({
  selector: 'app-view-plans',
  templateUrl: './view-plans.component.html',
  styleUrls: ['./view-plans.component.scss'],
  standalone: false
})
export class ViewPlansComponent implements OnInit, AfterViewInit {
  private readonly destroyRef = inject(DestroyRef);

  @ViewChild('countryMultiSelect') countryMultiSelect: MultiSelect | undefined;
  @ViewChild('productNameMultiSelect') productNameMultiSelect: MultiSelect | undefined;
  @ViewChildren(MultiSelect) multiSelectComponents!: QueryList<MultiSelect>;

  statusPlan = [

    { label: 'TRANSLATE.PRODUCT', value: ViewPlans.PRODUCT },
    { label: 'TRANSLATE.COVERAGE', value: ViewPlans.COVERAGE },
    { label: 'TRANSLATE.PRICE', value: ViewPlans.PRICE },
    { label: 'TRANSLATE.ELIGIBILITY', value: ViewPlans.ELIGIBILITY }
  ];

  countriesList: { label: string; value: string }[] = [];
  currencyOptions: { label: string; value: string }[] = [];
  priceTypeOptions: { label: string; value: string }[] = [];

  private buildPriceFiltersOptions(): void {

    this.currencyOptions = [
      { label: this.translateService.instant('TRANSLATE.SELECT.COUNTRY.CURRENCY.BRA'), value: ConstantsFordProtect.REAL },
      { label: this.translateService.instant('TRANSLATE.SELECT.COUNTRY.CURRENCY.OTHERS'), value: ConstantsFordProtect.PESO }
    ];

    this.priceTypeOptions = [
      { label: this.translateService.instant('TRANSLATE.SELECT.PRICE.CUSTOMER'), value: ConstantsFordProtect.PRICE_CUSTOMER },
      { label: this.translateService.instant('TRANSLATE.SELECT.SELLER.PRICE'), value: ConstantsFordProtect.SELLER_PRICE },
      { label: this.translateService.instant('TRANSLATE.SELECT.COST.FORD'), value: ConstantsFordProtect.COST_FORD },
      { label: this.translateService.instant('TRANSLATE.SELECT.COST.WARRANTY'), value: ConstantsFordProtect.COST_WARRANTY },
      { label: this.translateService.instant('TRANSLATE.SELECT.COST.SERVICE'), value: ConstantsFordProtect.COST_SERVICE }
    ];
  }

  buildStatusPlan(): void {
    this.statusPlan = [
      { label: this.translateService.instant('TRANSLATE.PRODUCT'), value: ViewPlans.PRODUCT },
      { label: this.translateService.instant('TRANSLATE.COVERAGE'), value: ViewPlans.COVERAGE },
      { label: this.translateService.instant('TRANSLATE.PRICE'), value: ViewPlans.PRICE },
      { label: this.translateService.instant('TRANSLATE.ELIGIBILITY'), value: ViewPlans.ELIGIBILITY }
    ];
  }

  selectTypePlan: ViewPlans = ViewPlans.PRODUCT;
  bottonItems: NewPlansApplication[] = [];
  selectedNewPlans: NewPlansApplication | null = null;
  product: PlanItem[] = [];
  coverage: CoverageCategoryOws | null = null;
  products: PlanItem[] = [];
  selectedProducts: PlanItem[] = [];

  private buildCountriesList(): void {
    const allCountries = [
      { label: this.translateService.instant('TRANSLATE.CHOOSE.COUNTRY.ARG'), value: ConstantsFordProtect.ARG },
      { label: this.translateService.instant('TRANSLATE.CHOOSE.COUNTRY.BRA'), value: ConstantsFordProtect.BRA },
      { label: this.translateService.instant('TRANSLATE.CHOOSE.COUNTRY.CHL'), value: ConstantsFordProtect.CHL },
      { label: this.translateService.instant('TRANSLATE.CHOOSE.COUNTRY.COL'), value: ConstantsFordProtect.COL },
      { label: this.translateService.instant('TRANSLATE.CHOOSE.COUNTRY.VEN'), value: ConstantsFordProtect.VEN }
    ];

    const hideVenezuelaForEligibility =
      this.systemCountry !== ConstantsFordProtect.VEN &&
      this.selectTypePlan === ViewPlans.ELIGIBILITY;

    this.countriesList = hideVenezuelaForEligibility
      ? allCountries.filter(country => country.value !== ConstantsFordProtect.VEN)
      : allCountries;

    this.selectedCountries = this.normalizeToArray(this.selectedCountries)
      .filter(country => this.countriesList.some(option => option.value === country));
  }

  selectedCountries: string[] = [];
  selectedProductsResult: PlanItem[] = [];
  countriesGet: string[] = [];
  priceSearchCriteria: PriceSearchCriteria = { currencies: [], priceTypes: [] };
  selectedCurrencies: string[] = [];
  selectedPriceTypes: string[] = [];
  selectPlaceholder: string | undefined;
  blockedUi = false;
  loadingPlans = false;
  filterButtonLoading = false;
  private countrySearchDebounceTimer: ReturnType<typeof setTimeout> | null = null;
  private readonly countrySearchDebounceMs = 3500;
  private readonly multiSelectPanelCloseDelayMs = 4000;
  private readonly multiSelectCloseTimers = new WeakMap<MultiSelect, ReturnType<typeof setTimeout>>();
  private hasPendingCountrySelection = false;
  private readonly statusTranslationByValue: Record<string, string> = {
    active: 'TRANSLATE.ACTIVE',
    inactive: 'TRANSLATE.INACTIVE',
    blocked: 'TRANSLATE.BLOCKED',
    canceled: 'TRANSLATE.CANCELED',
    cancelled: 'TRANSLATE.CANCELED',
    finished: 'TRANSLATE.FINISHED',
    created: 'TRANSLATE.CREATED',
    'pending payment': 'TRANSLATE.PENDING.PAYMENT',
    'pending cancellation': 'TRANSLATE.PENDING.CANCELLATION',
    'pending activation': 'TRANSLATE.PENDING.ACTIVATION',
    'pending amendment': 'TRANSLATE.PENDING.AMENDMENT',
    'with error': 'TRANSLATE.WITH.ERROR'
  };
  vehicleModel: string | undefined;
  customerPriceConcat: number | undefined;
  formattedCustomerPrice: string | undefined;
  idEligibility: number | undefined;
  idPrice: number | undefined;
  formattedItemPrice: number | undefined;
  productNameFilterText = '';
  lastProductNameFilterUsedForSelection = '';
  customersPricesConcat: number[] = [];
  systemCountry: string = '';

  constructor(

    public translateService: TranslateService,
    private messageService: MessageService,
    private router: Router,
    private productService: ProductService,
    private coverageService: CoverageService,
    private productPolicyService: ProductPolicyService,
    private priceService: PriceService,
    private countryName: CountryName,
    private searchByPriceName: SearchByPriceName,
    private onlyAcceptNumbers: OnlyAcceptNumbers,
    private systemCountryService: SystemCountryService

  ) {

    this.systemCountryService.setSystemCountry();
  }

  ngOnInit() {

    this.selectPlaceholder = this.translateService.instant('TRANSLATE.SELECT');
    this.systemCountry = this.systemCountryService.getSystemCountry();

    this.buildStatusPlan();

    if (!this.statusPlan.some(status => status.value === this.selectTypePlan)) {
      this.selectTypePlan = this.statusPlan.length > 0 ? this.statusPlan[0].value : ViewPlans.PRODUCT;
    }

    this.buildCountriesList();
    this.buildPriceFiltersOptions();

    // Update labels and menu captions when language changes.
    this.translateService.onLangChange.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {

      this.buildStatusPlan();
      this.buildCountriesList();
      this.selectPlaceholder = this.translateService.instant('TRANSLATE.SELECT');
      this.buildPriceFiltersOptions();
      this.products = this.enrichStatusSearchText(this.products);
      this.navMenuItemsArray();
    });

    this.getMenu();

    if (this.restoreStateFromSessionStorage()) {
      // Full snapshot restored (filters + results) — user returned from edit page

      // AUTO-REFRESH: Check if any item was recently edited
      // If yes, automatically re-search with the same criteria to show updated data

      // Check for edited PRICE
      const lastEditedPriceId = this.priceService.getAndClearLastEditedPriceId();
      if (lastEditedPriceId !== null && this.selectTypePlan === ViewPlans.PRICE) {
        const cachedCriteria = this.priceService.getCachedSearchCriteria();
        if (cachedCriteria) {
          this.autoRefreshSearchResults(cachedCriteria);
        }
      }

      // Check for edited PRODUCT
      const lastEditedProductId = this.productService.getAndClearLastEditedProductId();
      if (lastEditedProductId !== null && this.selectTypePlan === ViewPlans.PRODUCT) {
        const cachedCountries = this.productService.getCachedSearchCountries();
        if (cachedCountries && cachedCountries.length > 0) {
          this.autoRefreshSearchResultsProduct(cachedCountries);
        }
      }

      // Check for edited COVERAGE
      const lastEditedCoverageId = this.coverageService.getAndClearLastEditedCoverageId();
      if (lastEditedCoverageId !== null && this.selectTypePlan === ViewPlans.COVERAGE) {
        const cachedCountries = this.coverageService.getCachedSearchCountries();
        if (cachedCountries && cachedCountries.length > 0) {
          this.autoRefreshSearchResultsCoverage(cachedCountries);
        }
      }

      // Check for edited ELIGIBILITY
      const lastEditedEligibilityId = this.productPolicyService.getAndClearLastEditedEligibilityId();
      if (lastEditedEligibilityId !== null && this.selectTypePlan === ViewPlans.ELIGIBILITY) {
        const cachedCountries = this.productPolicyService.getCachedSearchCountries();
        if (cachedCountries && cachedCountries.length > 0) {
          this.autoRefreshSearchResultsEligibility(cachedCountries);
        }
      }
    } else if (localStorage.getItem(ViewPlansComponent.STATE_STORAGE_KEY)) {
      // Legacy fallback: entry written by older version
      this.restoreStateFromLocalStorage();
    }

    this.sanitizeFilterSelections();

    // SYNCHRONIZATION: Subscribe to price updates from edit page
    // When a price is updated in price-details-edit, update it here automatically
    // without requiring user to re-filter or reload
    this.priceService.getPriceUpdatedNotifier().pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(({ id, updatedPrice }) => {
      this.onPriceUpdated(id, updatedPrice);
    });

  }

  ngAfterViewInit(): void {
    setTimeout(() => this.sanitizeFilterSelections(), 0);
    setTimeout(() => this.sanitizeFilterSelections(), 300);
  }

  private isEmptyStringValue(value: unknown): boolean {
    return typeof value === 'string' && value.trim().toLowerCase() === 'empty';
  }

  private normalizeToArray<T>(value: T | T[] | null | undefined): T[] {
    if (value === null || value === undefined) {
      return [];
    }

    if (Array.isArray(value)) {
      return value;
    }

    return [value];
  }

  private isEmptyLikeItem(item: unknown): boolean {
    if (this.isEmptyStringValue(item)) {
      return true;
    }

    if (!item || typeof item !== 'object') {
      return false;
    }

    const record = item as Record<string, unknown>;
    const labelLikeFields = ['label', 'value', 'name', 'productCode', 'owsCategory', 'saleType', 'statusCode', 'vehicleLineN', 'vehicleLineC', 'tma'];
    const stringFields = labelLikeFields.filter(field => typeof record[field] === 'string');

    if (stringFields.length === 0) {
      return false;
    }

    return stringFields.every(field => this.isEmptyStringValue(record[field]));
  }

  private sanitizeFilterSelections(): void {
    this.selectedCountries = this.normalizeToArray(this.selectedCountries)
      .filter(country => !this.isEmptyLikeItem(country));

    this.selectedProducts = this.normalizeToArray(this.selectedProducts)
      .filter(item => !this.isEmptyLikeItem(item));

    this.product = this.normalizeToArray(this.product)
      .filter(item => !this.isEmptyLikeItem(item));

    if (this.product.length === 0 && this.selectedProducts.length > 0) {
      this.product = [...this.selectedProducts];
    }

    if (this.selectedProducts.length === 0 && this.product.length > 0) {
      this.selectedProducts = [...this.product];
    }
  }

  private getStatusTranslationKey(statusCode: string | null | undefined): string {
    if (!statusCode) {
      return '';
    }

    const normalizedStatusCode = statusCode.trim().toLowerCase();
    return this.statusTranslationByValue[normalizedStatusCode] ?? statusCode;
  }

  getLocalizedStatusLabel(statusCode: string | null | undefined): string {
    const keyOrRawValue = this.getStatusTranslationKey(statusCode);

    if (!keyOrRawValue) {
      return '';
    }

    return this.translateService.instant(keyOrRawValue);
  }

  private escapeRegex(value: string): string {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  formatProductIdName(item: PlanItem | null | undefined): string {
    if (!item || typeof item !== 'object') {
      return '';
    }

    const record = item as {
      id?: unknown;
      name?: unknown;
      productId?: unknown;
      productName?: unknown
    };

    // Support both naming conventions: ProductVisit (productId/productName) and CoverageCategoryOws (id/name)
    const idValue = record.id ?? record.productId;
    const nameValue = record.name ?? record.productName;

    const idText = idValue === null || idValue === undefined ? '' : String(idValue).trim();
    const nameText = typeof nameValue === 'string' ? nameValue.trim() : '';
    const hasPrefixedNumericName = /^\d+\s*-\s*\S+/.test(nameText);

    if (!idText) {
      return nameText;
    }

    if (!nameText) {
      return idText;
    }

    // Eligibility names can already come as "<productId> - <productName>".
    // In this case, avoid prepending the eligibility policy ID again.
    if (this.selectTypePlan === ViewPlans.ELIGIBILITY && hasPrefixedNumericName) {
      return nameText;
    }

    const escapedId = this.escapeRegex(idText);
    const duplicatePrefixPattern = new RegExp(`^${escapedId}\\s*-\\s*${escapedId}\\s*-\\s*`, 'i');
    const prefixedNamePattern = new RegExp(`^${escapedId}\\s*-\\s*`, 'i');

    if (duplicatePrefixPattern.test(nameText)) {
      return `${idText} - ${nameText.replace(duplicatePrefixPattern, '').trim()}`;
    }

    if (prefixedNamePattern.test(nameText)) {
      return nameText;
    }

    return `${idText} - ${nameText}`;
  }

  private enrichStatusSearchText(items: PlanItem[]): PlanItem[] {
    return items.map((item) => {
      if (!item || typeof item !== 'object') {
        return item;
      }

      const statusCode = (item as { statusCode?: unknown }).statusCode;
      if (typeof statusCode !== 'string' || !statusCode.trim()) {
        return item;
      }

      const localizedStatus = this.getLocalizedStatusLabel(statusCode);
      (item as { statusSearchText?: string }).statusSearchText = `${localizedStatus} ${statusCode}`.trim();
      return item;
    });
  }

  async getMenu() {

    // renderiza os itens de menu, na primeira vez que acessar a tela
    this.navMenuItemsArray();
  }

  async navMenuItemsArray() {

    this.bottonItems = [
      {
        label: this.translateService.instant('TRANSLATE.PRODUCT'),
        routerLink: '/new-product'
      },
      {
        label: this.translateService.instant('TRANSLATE.COVERAGE'),
        routerLink: '/new-coverage'
      },
      {
        label: this.translateService.instant('TRANSLATE.PRICE'),
        routerLink: '/new-price'
      },
      {
        label: this.translateService.instant('TRANSLATE.ELIGIBILITY'),
        routerLink: '/new-eligibility'
      }
    ];

  }

  changeLang(plan: string) {

    if (!plan) {
      return;
    }

    if (plan === this.translateService.instant('TRANSLATE.PRODUCT')) {
      this.router.navigate(['new-product'], { skipLocationChange: false, replaceUrl: false });

    } else if (plan === this.translateService.instant('TRANSLATE.COVERAGE')) {
      this.router.navigate(['new-coverage'], { skipLocationChange: false, replaceUrl: false });

    } else if (plan === this.translateService.instant('TRANSLATE.PRICE')) {
      this.router.navigate(['new-price'], { skipLocationChange: false, replaceUrl: false });

    } else if (plan === this.translateService.instant('TRANSLATE.ELIGIBILITY')) {
      this.router.navigate(['new-eligibility'], { skipLocationChange: false, replaceUrl: false });

    } else {
      this.messageService.add({
        severity: 'error',
        summary: this.translateService.instant('TRANSLATE.ERROR'),
        detail: this.translateService.instant('TRANSLATE.URL.NOT.FOUND')
      });
    }

  }

  generalSearch() {

    this.cancelPendingCountrySearch();
    this.hasPendingCountrySelection = false;
    this.cleanFilters();
    this.buildCountriesList();
  }

  countryChange(event: MultiSelectChangeEvent) {

    this.cleanFilters(true);

    this.selectedCountries = event.value;
    this.hasPendingCountrySelection = true;
    this.scheduleCountryAutoSearch();
  }

  countrySelectionPanelHide() {

    if (!this.hasPendingCountrySelection) {
      return;
    }

    this.cancelPendingCountrySearch();
    this.hasPendingCountrySelection = false;
    this.executeCountryAutoSearch();
  }

  private cancelPendingCountrySearch(): void {
    if (this.countrySearchDebounceTimer) {
      clearTimeout(this.countrySearchDebounceTimer);
      this.countrySearchDebounceTimer = null;
    }
  }

  private stopLoading(): void {
    this.loadingPlans = false;
    this.filterButtonLoading = false;
  }

  private scheduleCountryAutoSearch(): void {
    this.cancelPendingCountrySearch();

    if (!this.selectedCountries || this.selectedCountries.length === 0) {
      this.blockedUi = false;
      this.stopLoading();
      return;
    }

    this.countrySearchDebounceTimer = setTimeout(() => {
      this.countrySearchDebounceTimer = null;
      this.hasPendingCountrySelection = false;
      this.executeCountryAutoSearch();
    }, this.countrySearchDebounceMs);
  }

  private executeCountryAutoSearch(): void {
    if (!this.selectedCountries || this.selectedCountries.length === 0) {
      this.blockedUi = false;
      this.stopLoading();
      return;
    }

    this.countryMultiSelect?.hide();
    this.blockedUi = true;
    this.getAllPlansByCountry(false); // Auto-search: only loads filter data, never updates the table
  }

  scheduleMultiSelectPanelClose(multiSelect: MultiSelect) {
    if (!multiSelect) {
      return;
    }

    this.cancelMultiSelectPanelClose(multiSelect);

    const timeoutId = setTimeout(() => {
      if (multiSelect && multiSelect.overlayVisible && typeof multiSelect.hide === 'function') {
        multiSelect.hide();
      }
      this.multiSelectCloseTimers.delete(multiSelect);
    }, this.multiSelectPanelCloseDelayMs);

    this.multiSelectCloseTimers.set(multiSelect, timeoutId);
  }

  cancelMultiSelectPanelClose(multiSelect: MultiSelect) {
    if (!multiSelect) {
      return;
    }

    const timeoutId = this.multiSelectCloseTimers.get(multiSelect);

    if (timeoutId) {
      clearTimeout(timeoutId);
      this.multiSelectCloseTimers.delete(multiSelect);
    }
  }

  productChange(event: MultiSelectChangeEvent) {
    this.selectedProducts = event.value;
    this.lastProductNameFilterUsedForSelection = this.normalizeFilterText(this.getCurrentProductNameFilterText());
  }

  private syncSelectedProductsFromModel(): void {
    this.selectedProducts = this.normalizeToArray(this.product)
      .filter(item => !this.isEmptyLikeItem(item));
  }

  private normalizeFilterText(value: string | null | undefined): string {
    return (value ?? '').trim().toLowerCase();
  }

  private getCurrentProductNameFilterText(): string {
    const productNameMultiSelect = this.productNameMultiSelect as MultiSelect & {
      filterValue?: string | null;
    };

    const filterFromComponent = typeof productNameMultiSelect?.filterValue === 'string'
      ? productNameMultiSelect.filterValue
      : '';

    return filterFromComponent || this.productNameFilterText;
  }

  private filterProductsByTypedName(items: PlanItem[]): PlanItem[] {
    const normalizedFilter = this.normalizeFilterText(this.getCurrentProductNameFilterText());

    if (!normalizedFilter) {
      return [];
    }

    return items.filter(item => {
      const optionLabel = this.formatProductIdName(item);
      return this.normalizeFilterText(optionLabel).includes(normalizedFilter);
    });
  }

  private shouldPrioritizeTypedNameFilter(filteredProductsByName: PlanItem[]): boolean {
    const hasTypedFilter = this.normalizeFilterText(this.getCurrentProductNameFilterText()).length > 0;
    return hasTypedFilter && this.selectedProducts.length === 0 && filteredProductsByName.length > 0;
  }

  productNameFilterChange(event: { filter?: string } | null | undefined) {
    const nextFilterText = typeof event?.filter === 'string' ? event.filter : '';
    const normalizedNextFilter = this.normalizeFilterText(nextFilterText);
    const normalizedSelectionFilter = this.normalizeFilterText(this.lastProductNameFilterUsedForSelection);

    this.productNameFilterText = nextFilterText;

    if (normalizedNextFilter !== normalizedSelectionFilter && this.selectedProducts.length > 0) {
      this.selectedProducts = [];
      this.product = [];
    }
  }

  currencyChange(event: MultiSelectChangeEvent) {

    this.selectedCurrencies = event.value;
    this.updateSearchCriteria();
  }

  priceTypeChange(event: MultiSelectChangeEvent) {

    this.selectedPriceTypes = event.value;
    this.updateSearchCriteria();
  }

  updateSearchCriteria() {

    if (this.selectedCurrencies === undefined) {

      this.priceSearchCriteria.currencies = [];
    } else {

      this.priceSearchCriteria.currencies = this.selectedCurrencies;
    }
    if (this.selectedPriceTypes === undefined) {

      this.priceSearchCriteria.priceTypes = [];
    } else {

      this.priceSearchCriteria.priceTypes = this.selectedPriceTypes;
    }

    return this.priceSearchCriteria;
  }

  searchForAllPricesAndCanHaveCurrencyAndPriceTypeCriteria() {

    if (this.selectTypePlan === ViewPlans.PRICE) {

      this.loadingPlans = true;

      // CRITICAL: Cache criteria ALWAYS, regardless of pre-selected items or backend fetch
      // This ensures auto-refresh can re-apply the same search when user returns from editing
      const criteria = this.updateSearchCriteria();
      this.priceService.cacheSearchCriteria(criteria);

      if (this.selectedProducts.length > 0) {

        this.selectedProductsResult = this.selectedProducts;
        this.blockedUi = false;
        this.stopLoading();
      } else {

        this.priceService.searchPrice(criteria)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe((response: PriceDto[]) => {

            this.products = response.map(objProduct => {

              objProduct.itemName = this.searchByPriceName.getPriceName(objProduct.itemName);
              objProduct.formattedItemPrice = this.onlyAcceptNumbers
                .formattingFrontPrice(objProduct.itemPrice, objProduct.itemPriceUnit);
              return objProduct;
            });

            this.blockedUi = false;
            this.stopLoading();

            this.checkSelectedProducts();

            if (this.products.length === 0) {

              this.blockedUi = false;
              this.stopLoading();
              this.messageService.add({
                severity: 'error',
                summary: this.translateService.instant('TRANSLATE.ERROR'),
                detail: this.translateService.instant('TRANSLATE.NO.RESULT.FOUND')
              });
            }

          }, (err) => {

            this.blockedUi = false;
            this.stopLoading();
            if (err.status === 400) {
              this.messageService.add({
                severity: 'error',
                summary: this.translateService.instant('TRANSLATE.ERROR'),
                detail: this.translateService.instant('TRANSLATE.PRICE.NOT.FOUND')
              });
            } else if (err.status === 401) {

              this.messageService.add({
                severity: 'error',
                summary: this.translateService.instant('TRANSLATE.ERROR'),
                detail: this.translateService.instant('TRANSLATE.USER.WITHOUT.PERMISSION.REFRESH.PAGE')
              });

            } else {

              this.messageService.add({
                severity: 'error',
                summary: this.translateService.instant('TRANSLATE.ERROR'),
                detail: this.translateService.instant('TRANSLATE.ERROR.CONTACT.SYSTEM.ADMINISTRATOR')
              });
            }

          });

      }

    }

  }

  getAllPlansByCountry(updateTable: boolean = true) {

    this.blockedUi = true;

    switch (this.selectTypePlan) {

      case ViewPlans.PRODUCT:

        this.loadingPlans = true;

        // CRITICAL: Cache countries ALWAYS, regardless of pre-selected items or backend fetch
        // This ensures auto-refresh can re-apply the same search when user returns from editing
        if (this.selectedCountries && this.selectedCountries.length > 0) {
          this.productService.cacheSearchCountries(this.selectedCountries);
        }

        if (this.selectedProducts.length > 0) {

          this.checkSelectedProducts();
          this.blockedUi = false;
          this.stopLoading();

        } else {

          if (!this.selectedCountries || this.selectedCountries.length === 0) {

            this.messageService.add({
              severity: 'error',
              summary: this.translateService.instant('TRANSLATE.ERROR'),
              detail: this.translateService.instant('TRANSLATE.MESSAGE.SELECT.COUNTRIES')
            });
            this.blockedUi = false;
            this.stopLoading();
            return;
          }

          this.productService.getProductsByCountry(this.selectedCountries)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((response: ProductVisit[]) => {

              this.products = response.map(objProduct => {

                objProduct.country = this.countryName.getCountryName(objProduct.country);
                return objProduct;
              });

              this.blockedUi = false;
              this.stopLoading();

              if (updateTable) {
                this.checkSelectedProducts();
              }

              if (updateTable && this.products.length === 0) {

                this.blockedUi = false;
                this.stopLoading();
                this.messageService.add({
                  severity: 'error',
                  summary: this.translateService.instant('TRANSLATE.ERROR'),
                  detail: this.translateService.instant('TRANSLATE.NO.RESULT.FOUND')
                });
              }

            }, (err) => {

              this.blockedUi = false;
              this.stopLoading();
              if (err.status === 400) {

                this.messageService.add({
                  severity: 'error',
                  summary: this.translateService.instant('TRANSLATE.ERROR'),
                  detail: this.translateService.instant('TRANSLATE.PRODUCTS.NOT.FOUND')
                });
              } else if (err.status === 401) {

                this.messageService.add({
                  severity: 'error',
                  summary: this.translateService.instant('TRANSLATE.ERROR'),
                  detail: this.translateService.instant('TRANSLATE.USER.WITHOUT.PERMISSION.REFRESH.PAGE')
                });

              } else {

                this.messageService.add({
                  severity: 'error',
                  summary: this.translateService.instant('TRANSLATE.ERROR'),
                  detail: this.translateService.instant('TRANSLATE.ERROR.CONTACT.SYSTEM.ADMINISTRATOR')
                });
              }

            });
        }
        break;

      case ViewPlans.COVERAGE:

        this.loadingPlans = true;

        // CRITICAL: Cache countries ALWAYS, regardless of pre-selected items or backend fetch
        // This ensures auto-refresh can re-apply the same search when user returns from editing
        if (this.selectedCountries && this.selectedCountries.length > 0) {
          this.coverageService.cacheSearchCountries(this.selectedCountries);
        }

        if (this.selectedProducts.length > 0) {

          this.checkSelectedProducts();
          this.blockedUi = false;
          this.stopLoading();

        } else {

          if (!this.selectedCountries || this.selectedCountries.length === 0) {

            this.messageService.add({
              severity: 'error',
              summary: this.translateService.instant('TRANSLATE.ERROR'),
              detail: this.translateService.instant('TRANSLATE.MESSAGE.SELECT.COUNTRIES')
            });
            this.blockedUi = false;
            this.stopLoading();
            return;
          }

          this.coverageService.getCoveragesByCountry(this.selectedCountries)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((response: CoverageCategoryOws[]) => {

              this.products = response.map(objCoverage => {
                objCoverage.country = this.countryName.getCountryName(objCoverage.country);
                return objCoverage;
              });

              this.blockedUi = false;
              this.stopLoading();

              if (updateTable) {
                this.checkSelectedProducts();
              }

              if (updateTable && this.products.length === 0) {

                this.blockedUi = false;
                this.stopLoading();
                this.messageService.add({
                  severity: 'error',
                  summary: this.translateService.instant('TRANSLATE.ERROR'),
                  detail: this.translateService.instant('TRANSLATE.NO.RESULT.FOUND')
                });
              }

            }, (err) => {

              this.blockedUi = false;
              this.stopLoading();
              if (err.status === 400) {

                this.messageService.add({
                  severity: 'error',
                  summary: this.translateService.instant('TRANSLATE.ERROR'),
                  detail: this.translateService.instant('TRANSLATE.COVERAGE.NOT.FOUND')
                });
              } else if (err.status === 401) {

                this.messageService.add({
                  severity: 'error',
                  summary: this.translateService.instant('TRANSLATE.ERROR'),
                  detail: this.translateService.instant('TRANSLATE.USER.WITHOUT.PERMISSION.REFRESH.PAGE')
                });

              } else {

                this.messageService.add({
                  severity: 'error',
                  summary: this.translateService.instant('TRANSLATE.ERROR'),
                  detail: this.translateService.instant('TRANSLATE.ERROR.CONTACT.SYSTEM.ADMINISTRATOR')
                });
              }

            });
        }
        break;

      case ViewPlans.ELIGIBILITY:

        this.loadingPlans = true;

        // CRITICAL: Cache countries ALWAYS, regardless of pre-selected items or backend fetch
        // This ensures auto-refresh can re-apply the same search when user returns from editing
        if (this.selectedCountries && this.selectedCountries.length > 0) {
          this.productPolicyService.cacheSearchCountries(this.selectedCountries);
        }

        if (this.selectedProducts.length > 0) {

          this.checkSelectedProducts();
          this.blockedUi = false;
          this.stopLoading();

        } else {

          if (!this.selectedCountries || this.selectedCountries.length === 0) {

            this.messageService.add({
              severity: 'error',
              summary: this.translateService.instant('TRANSLATE.ERROR'),
              detail: this.translateService.instant('TRANSLATE.MESSAGE.SELECT.COUNTRIES')
            });
            this.blockedUi = false;
            this.stopLoading();
            return;
          }

          this.productPolicyService.getAllProductPoliciesByCountry(this.selectedCountries)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((response: ProductPolicy[]) => {

              this.products = response.map(objEligibility => {

                objEligibility.country = this.countryName.getCountryName(objEligibility.country);
                objEligibility.formattedCustomerPrice = this.onlyAcceptNumbers
                  .formattingFrontPrice(objEligibility.customerPrice, objEligibility.unityPrice);
                return objEligibility;
              });
              this.products = this.enrichStatusSearchText(this.products);
              this.blockedUi = false;
              this.stopLoading();

              if (updateTable) {
                this.checkSelectedProducts();
              }

              if (updateTable && this.products.length === 0) {

                this.blockedUi = false;
                this.stopLoading();
                this.messageService.add({
                  severity: 'error',
                  summary: this.translateService.instant('TRANSLATE.ERROR'),
                  detail: this.translateService.instant('TRANSLATE.NO.RESULT.FOUND')
                });
              }

            }, (_err) => {

              this.blockedUi = false;
              this.stopLoading();
              if (_err.status === 400) {
                this.messageService.add({
                  severity: 'error',
                  summary: this.translateService.instant('TRANSLATE.ERROR'),
                  detail: this.translateService.instant('TRANSLATE.ELEGIBILITY.NOT.FOUND')
                });
              } else if (_err.status === 401) {

                this.messageService.add({
                  severity: 'error',
                  summary: this.translateService.instant('TRANSLATE.ERROR'),
                  detail: this.translateService.instant('TRANSLATE.USER.WITHOUT.PERMISSION.REFRESH.PAGE')
                });

              } else {

                this.messageService.add({
                  severity: 'error',
                  summary: this.translateService.instant('TRANSLATE.ERROR'),
                  detail: this.translateService.instant('TRANSLATE.ERROR.CONTACT.SYSTEM.ADMINISTRATOR')
                });
              }

            });
        }
        break;

    }

  }



  get secondaryFiltersDisabled(): boolean {
    return this.selectTypePlan !== ViewPlans.PRICE && this.products.length === 0;
  }

  get searchButtonDisabled(): boolean {
    if (this.loadingPlans) {
      return true;
    }
    if (this.selectTypePlan !== ViewPlans.PRICE) {
      return this.selectedCountries.length === 0 || this.products.length === 0;
    }
    return this.products.length === 0;
  }

  validateSearch() {

    this.syncSelectedProductsFromModel();

    if (this.selectTypePlan === ViewPlans.PRICE) {

      if (this.products.length === 0) {

        this.messageService.add({
          severity: 'error',
          summary: this.translateService.instant('TRANSLATE.ERROR'),
          detail: this.translateService.instant('TRANSLATE.NO.PRICES.AVAILABLE.FOR.THIS.SEARCH')
        });

      } else {

        this.filterButtonLoading = true;
        this.blockedUi = true;
        this.searchForAllPricesAndCanHaveCurrencyAndPriceTypeCriteria();
        this.checkSelectedProducts();
      }

    } else {

      if (this.selectedCountries.length > 0) {

        this.filterButtonLoading = true;
        this.blockedUi = true;
        this.getAllPlansByCountry();

      } else {

        this.messageService.add({
          severity: 'error',
          summary: this.translateService.instant('TRANSLATE.ERROR'),
          detail: this.translateService.instant('TRANSLATE.SELECT.COUNTRIES')
        });
      }

    }

  }

  clearTable() {

    this.selectedProductsResult = [];
    this.selectedProducts = [];
    this.product = [];
    this.productNameFilterText = '';
    this.lastProductNameFilterUsedForSelection = '';
  }

  private clearProductSelectionState(): void {
    this.selectedProductsResult = [];
    this.selectedProducts = [];
    this.product = [];

    const productNameMultiSelect = this.productNameMultiSelect as MultiSelect & {
      modelValue?: { set: (value: unknown[]) => void };
      updateModel?: (value: unknown[], event: Event | null) => void;
      onModelChange?: (value: unknown[]) => void;
      value?: unknown[];
    };

    if (!productNameMultiSelect) {
      return;
    }

    // PrimeNG 17+ can expose modelValue as WritableSignal; avoid direct assignment.
    productNameMultiSelect.value = [];
    if (productNameMultiSelect.modelValue && typeof productNameMultiSelect.modelValue.set === 'function') {
      productNameMultiSelect.modelValue.set([]);
    }
    productNameMultiSelect.updateModel?.([], null);
    productNameMultiSelect.onModelChange?.([]);
  }

  cleanFilters(clearCountries: boolean = true) {

    this.stopLoading();
    this.products = [];
    this.selectedProductsResult = [];
    if (clearCountries) {
      this.selectedCountries = [];
    }
    this.clearProductSelectionState();
    this.selectedCurrencies = [];
    this.selectedPriceTypes = [];
    this.productNameFilterText = '';
    this.lastProductNameFilterUsedForSelection = '';
    this.resetMultiSelectFilters();
    setTimeout(() => {
      this.clearProductSelectionState();
      // When switching to Price view, load available prices but don't populate the results table.
      // Call this AFTER DOM reset to avoid timing issues.
      if (this.selectTypePlan === ViewPlans.PRICE) {
        this.loadAvailablePricesForFilter();
      }
    }, 0);
  }

  private loadAvailablePricesForFilter(): void {
    this.blockedUi = true;
    this.loadingPlans = true;

    const criteria = this.updateSearchCriteria();
    // Cache the search criteria so we can auto-reapply it when user returns from editing
    this.priceService.cacheSearchCriteria(criteria);

    this.priceService.searchPrice(criteria)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response: PriceDto[]) => {

        this.products = response.map(objProduct => {

          objProduct.itemName = this.searchByPriceName.getPriceName(objProduct.itemName);
          objProduct.formattedItemPrice = this.onlyAcceptNumbers
            .formattingFrontPrice(objProduct.itemPrice, objProduct.itemPriceUnit);
          return objProduct;
        });

        this.blockedUi = false;
        this.stopLoading();

      }, (err) => {

        this.blockedUi = false;
        this.stopLoading();
        if (err.status === 400) {
          this.messageService.add({
            severity: 'error',
            summary: this.translateService.instant('TRANSLATE.ERROR'),
            detail: this.translateService.instant('TRANSLATE.PRICE.NOT.FOUND')
          });
        } else if (err.status === 401) {

          this.messageService.add({
            severity: 'error',
            summary: this.translateService.instant('TRANSLATE.ERROR'),
            detail: this.translateService.instant('TRANSLATE.USER.WITHOUT.PERMISSION.REFRESH.PAGE')
          });

        } else {

          this.messageService.add({
            severity: 'error',
            summary: this.translateService.instant('TRANSLATE.ERROR'),
            detail: this.translateService.instant('TRANSLATE.ERROR.CONTACT.SYSTEM.ADMINISTRATOR')
          });
        }

      });
  }

  clearSearchFilter() {

    this.cancelPendingCountrySearch();
    this.hasPendingCountrySelection = false;
    this.cleanFilters();
    this.selectTypePlan = this.statusPlan.length > 0 ? this.statusPlan[0].value : ViewPlans.PRODUCT;
    this.sanitizeFilterSelections();
    setTimeout(() => this.resetMultiSelectFilters(), 0);
  }

  private resetMultiSelectFilters(): void {
    if (!this.multiSelectComponents) {
      return;
    }

    this.multiSelectComponents.forEach((multiSelect) => {
      const multiSelectWithFilter = multiSelect as MultiSelect & {
        resetFilter?: () => void;
        filterValue?: string | null;
      };

      multiSelectWithFilter.resetFilter?.();

      if ('filterValue' in multiSelectWithFilter) {
        multiSelectWithFilter.filterValue = null;
      }
    });
  }

  checkSelectedProducts() {

    this.syncSelectedProductsFromModel();

    const filteredProductsByName = this.filterProductsByTypedName(this.products);

    if (this.shouldPrioritizeTypedNameFilter(filteredProductsByName)) {

      this.selectedProductsResult = filteredProductsByName;
      return;
    }

    if (this.selectedProducts.length > 0) {

      this.selectedProductsResult = this.selectedProducts;
    } else {

      this.selectedProductsResult = this.products;
    }
  }

  /**
   * Synchronizes selectedProducts with the latest data in products array.
   * Called after auto-refresh to ensure selected items point to fresh data.
   * 
   * CRITICAL FIX: When user selects items, then edits and returns, the snapshot
   * restoration gives us old object references. This method re-maps selectedProducts
   * to use the fresh objects from the updated products array.
   * 
   * CRITICAL: Also updates this.product (dropdown model) so that syncSelectedProductsFromModel()
   * doesn't overwrite selectedProducts with stale data when checkSelectedProducts() is called.
   * 
   * Without this, subsequent Filter clicks would use stale data because
   * getAllPlansByCountry() sees selectedProducts.length > 0 and skips the backend fetch.
   */
  private resyncSelectedProductsWithFreshData(): void {
    if (this.selectedProducts.length === 0 || this.products.length === 0) {
      return; // Nothing to sync
    }

    // Re-map selectedProducts to use fresh references from this.products
    const freshSelectedProducts: PlanItem[] = [];

    for (const oldSelection of this.selectedProducts) {
      // Get the ID from the old selection (works for all types: id, productPolicyId)
      const oldId = typeof oldSelection === 'object' && oldSelection !== null
        ? (oldSelection as unknown as Record<string, unknown>).id
        : null;

      if (oldId === null) {
        // Can't find ID, keep the old reference (shouldn't happen)
        freshSelectedProducts.push(oldSelection);
        continue;
      }

      // Find the fresh item in this.products by ID
      const freshItem = this.products.find(item =>
        typeof item === 'object' && item !== null && (item as unknown as Record<string, unknown>).id === oldId
      );

      if (freshItem) {
        // Use the fresh reference from the updated products array
        freshSelectedProducts.push(freshItem);
      } else {
        // Item not found in fresh data (might have been deleted), keep old reference
        freshSelectedProducts.push(oldSelection);
      }
    }

    // Replace with fresh references
    this.selectedProducts = freshSelectedProducts;

    // CRITICAL: Also update this.product (dropdown model) so that when checkSelectedProducts()
    // calls syncSelectedProductsFromModel(), it reads fresh references and doesn't overwrite
    // selectedProducts with stale/empty data. Without this, the sync is reversed!
    this.product = [...freshSelectedProducts];
  }

  private saveSnapshotToSessionStorage(): void {
    const snapshot: ViewPlansSnapshot = {
      selectTypePlan: this.selectTypePlan,
      selectedCountries: this.selectedCountries,
      selectedCurrencies: this.selectedCurrencies,
      selectedPriceTypes: this.selectedPriceTypes,
      products: this.products,
      selectedProducts: this.selectedProducts,
      selectedProductsResult: this.selectedProductsResult,
    };

    try {
      sessionStorage.setItem(ViewPlansComponent.SESSION_SNAPSHOT_KEY, JSON.stringify(snapshot));
    } catch {
      // sessionStorage unavailable (private mode / quota); silently ignore
    }
  }

  /** Returns true when a valid snapshot was found and applied. */
  private restoreStateFromSessionStorage(): boolean {
    let raw: string | null;

    try {
      raw = sessionStorage.getItem(ViewPlansComponent.SESSION_SNAPSHOT_KEY);
      sessionStorage.removeItem(ViewPlansComponent.SESSION_SNAPSHOT_KEY);
    } catch {
      return false;
    }

    if (!raw) {
      return false;
    }

    try {
      const snapshot = JSON.parse(raw) as Partial<ViewPlansSnapshot>;
      const validPlanValues = this.statusPlan.map(s => s.value);

      if (typeof snapshot.selectTypePlan === 'string' && validPlanValues.includes(snapshot.selectTypePlan as ViewPlans)) {
        this.selectTypePlan = snapshot.selectTypePlan as ViewPlans;
      }
      this.selectedCountries = Array.isArray(snapshot.selectedCountries) ? snapshot.selectedCountries : [];
      this.selectedCurrencies = Array.isArray(snapshot.selectedCurrencies) ? snapshot.selectedCurrencies : [];
      this.selectedPriceTypes = Array.isArray(snapshot.selectedPriceTypes) ? snapshot.selectedPriceTypes : [];
      this.products = Array.isArray(snapshot.products) ? snapshot.products : [];
      this.products = this.enrichStatusSearchText(this.products);
      this.selectedProducts = Array.isArray(snapshot.selectedProducts) ? snapshot.selectedProducts : [];
      this.selectedProductsResult = Array.isArray(snapshot.selectedProductsResult) ? snapshot.selectedProductsResult : [];
      this.sanitizeFilterSelections();
      return true;
    } catch {
      return false;
    }
  }

  private navigateWithFiltersState(commands: unknown[], extras: NavigationExtras = {}): void {
    this.saveSnapshotToSessionStorage();
    this.router.navigate(commands, extras);
  }

  editProductButton(idProduct: number) {
    this.navigateWithFiltersState(['/product-details-edit', idProduct]);
  }

  editCoverageButton(idCoverage: number) {
    this.navigateWithFiltersState(['/coverage-details-edit', idCoverage]);
  }

  editPriceButton(idPrice: number) {
    this.navigateWithFiltersState(['/price-details-edit', idPrice]);
  }

  editEligibilityButton(idEligibility: number) {
    this.navigateWithFiltersState(['/eligibility-details-edit', idEligibility]);
  }

  /**
   * Automatically refreshes the search results after returning from edit page.
   * This is transparent to the user — no manual "Filter" button click needed.
   * Ensures that updated data is always displayed without extra friction.
   * 
   * CRITICAL: This runs AFTER snapshot restoration, so it overwrites stale data with fresh data.
   */
  private autoRefreshSearchResults(criteria: PriceSearchCriteria): void {
    this.loadingPlans = true;
    this.blockedUi = true;

    this.priceService.searchPrice(criteria)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response: PriceDto[]) => {
        // Update products with fresh data (overwriting stale snapshot)
        this.products = response.map(objProduct => {
          objProduct.itemName = this.searchByPriceName.getPriceName(objProduct.itemName);
          objProduct.formattedItemPrice = this.onlyAcceptNumbers
            .formattingFrontPrice(objProduct.itemPrice, objProduct.itemPriceUnit);
          return objProduct;
        });

        // CRITICAL: Re-sync selectedProducts with fresh data BEFORE checkSelectedProducts
        // This ensures checkSelectedProducts() reads fresh references from this.product
        // instead of stale ones. Order matters: sync first, then populate table.
        this.resyncSelectedProductsWithFreshData();

        // Also update the results table if applicable
        this.checkSelectedProducts();

        this.blockedUi = false;
        this.stopLoading();
      }, (_err) => {
        this.blockedUi = false;
        this.stopLoading();
        // Silently fail — user still has snapshot data visible
      });
  }

  /**
   * Updates a price in the products list when it's been modified in the edit page.
   * This ensures that after returning from price-details-edit, the table displays
   * the updated values without requiring the user to re-filter or reload.
   * 
   * Called via subscription to priceService.getPriceUpdatedNotifier() in ngOnInit.
   */
  private onPriceUpdated(priceId: number, updatedPrice: PriceDto): void {
    // Find and update the price in the products list
    const priceIndex = this.products.findIndex(product => {
      // PriceDto has an 'id' property; check if this product matches
      return typeof product === 'object' && product !== null && 'id' in product && (product as unknown as Record<string, unknown>).id === priceId;
    });

    if (priceIndex >= 0) {
      // Replace the old price with the updated one
      this.products[priceIndex] = updatedPrice;

      // If this price is also in selectedProductsResult, update it there too
      const resultIndex = this.selectedProductsResult.findIndex(product => {
        return typeof product === 'object' && product !== null && 'id' in product && (product as unknown as Record<string, unknown>).id === priceId;
      });

      if (resultIndex >= 0) {
        this.selectedProductsResult[resultIndex] = updatedPrice;
      }

      // Refresh the enriched text (status translations, etc.) for the updated item
      this.products = this.enrichStatusSearchText(this.products);

      // Trigger change detection to update the table display
      this.navMenuItemsArray();
    }
  }

  /**
   * Auto-refresh search results for PRODUCT when user returns from editing.
   * Re-applies the last search to get fresh data without requiring user to click Filter.
   */
  private autoRefreshSearchResultsProduct(countries: string[]): void {
    this.loadingPlans = true;
    this.blockedUi = true;

    this.productService.getProductsByCountry(countries)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response: ProductVisit[]) => {
        // Update products with fresh data (overwriting stale snapshot)
        this.products = response.map(objProduct => {
          objProduct.country = this.countryName.getCountryName(objProduct.country);
          return objProduct;
        });

        // CRITICAL: Re-sync selectedProducts with fresh data BEFORE checkSelectedProducts
        // This ensures checkSelectedProducts() reads fresh references from this.product
        // instead of stale ones. Order matters: sync first, then populate table.
        this.resyncSelectedProductsWithFreshData();

        // Also update the results table if applicable
        this.checkSelectedProducts();

        this.blockedUi = false;
        this.stopLoading();
      }, (_err) => {
        this.blockedUi = false;
        this.stopLoading();
        // Silently fail — user still has snapshot data visible
      });
  }

  /**
   * Auto-refresh search results for COVERAGE when user returns from editing.
   * Re-applies the last search to get fresh data without requiring user to click Filter.
   */
  private autoRefreshSearchResultsCoverage(countries: string[]): void {
    this.loadingPlans = true;
    this.blockedUi = true;

    this.coverageService.getCoveragesByCountry(countries)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response: CoverageCategoryOws[]) => {
        // Update products with fresh data (overwriting stale snapshot)
        this.products = response.map(objCoverage => {
          objCoverage.country = this.countryName.getCountryName(objCoverage.country);
          return objCoverage;
        });

        // CRITICAL: Re-sync selectedProducts with fresh data BEFORE checkSelectedProducts
        // This ensures checkSelectedProducts() reads fresh references from this.product
        // instead of stale ones. Order matters: sync first, then populate table.
        this.resyncSelectedProductsWithFreshData();

        // Also update the results table if applicable
        this.checkSelectedProducts();

        this.blockedUi = false;
        this.stopLoading();
      }, (_err) => {
        this.blockedUi = false;
        this.stopLoading();
        // Silently fail — user still has snapshot data visible
      });
  }

  /**
   * Auto-refresh search results for ELIGIBILITY when user returns from editing.
   * Re-applies the last search to get fresh data without requiring user to click Filter.
   */
  private autoRefreshSearchResultsEligibility(countries: string[]): void {
    this.loadingPlans = true;
    this.blockedUi = true;

    this.productPolicyService.getAllProductPoliciesByCountry(countries)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response: ProductPolicy[]) => {
        // Update products with fresh data (overwriting stale snapshot)
        this.products = response.map(objEligibility => {
          objEligibility.country = this.countryName.getCountryName(objEligibility.country);
          objEligibility.formattedCustomerPrice = this.onlyAcceptNumbers
            .formattingFrontPrice(objEligibility.customerPrice, objEligibility.unityPrice);
          return objEligibility;
        });
        this.products = this.enrichStatusSearchText(this.products);

        // CRITICAL: Re-sync selectedProducts with fresh data BEFORE checkSelectedProducts
        // This ensures checkSelectedProducts() reads fresh references from this.product
        // instead of stale ones. Order matters: sync first, then populate table.
        this.resyncSelectedProductsWithFreshData();

        // Also update the results table if applicable
        this.checkSelectedProducts();

        this.blockedUi = false;
        this.stopLoading();
      }, (_err) => {
        this.blockedUi = false;
        this.stopLoading();
        // Silently fail — user still has snapshot data visible
      });
  }

  private static readonly STATE_STORAGE_KEY = 'viewPlansState';
  private static readonly SESSION_SNAPSHOT_KEY = 'viewPlansSnapshot';
  private static readonly STATE_VERSION = 2;
  private static readonly STATE_TTL_MS = 30 * 60 * 1000; // 30 minutes

  private applyRestoredFilters(filters: ViewPlansFilters): void {
    const validPlanValues = this.statusPlan.map(s => s.value);

    if (validPlanValues.includes(filters.selectTypePlan as ViewPlans)) {
      this.selectTypePlan = filters.selectTypePlan as ViewPlans;
    }
    this.selectedCountries = Array.isArray(filters.selectedCountries) ? filters.selectedCountries : [];
    this.selectedCurrencies = Array.isArray(filters.selectedCurrencies) ? filters.selectedCurrencies : [];
    this.selectedPriceTypes = Array.isArray(filters.selectedPriceTypes) ? filters.selectedPriceTypes : [];
    this.sanitizeFilterSelections();
  }

  /** @deprecated — kept only as fallback for users with existing localStorage entries */
  saveStateToLocalStorage() {

    const payload = {
      version: ViewPlansComponent.STATE_VERSION,
      savedAt: Date.now(),
      data: {
        selectTypePlan: this.selectTypePlan,
        selectedCountries: this.selectedCountries,
        selectedCurrencies: this.selectedCurrencies,
        selectedPriceTypes: this.selectedPriceTypes,
      },
    };

    try {
      localStorage.setItem(ViewPlansComponent.STATE_STORAGE_KEY, JSON.stringify(payload));
    } catch {
      // localStorage may be unavailable (private mode / quota exceeded); silently ignore
    }
  }

  restoreStateFromLocalStorage() {

    let raw: string | null;

    try {
      raw = localStorage.getItem(ViewPlansComponent.STATE_STORAGE_KEY);
    } catch {
      return;
    }

    if (!raw) {
      return;
    }

    try {
      const payload = JSON.parse(raw) as {
        version?: number;
        savedAt?: number;
        data?: {
          selectTypePlan?: unknown;
          selectedCountries?: unknown;
          selectedCurrencies?: unknown;
          selectedPriceTypes?: unknown;
        };
      };

      const isExpired = typeof payload.savedAt === 'number'
        && (Date.now() - payload.savedAt) > ViewPlansComponent.STATE_TTL_MS;

      const isWrongVersion = payload.version !== ViewPlansComponent.STATE_VERSION;

      if (isExpired || isWrongVersion || !payload.data) {
        localStorage.removeItem(ViewPlansComponent.STATE_STORAGE_KEY);
        return;
      }

      const { data } = payload;
      const validPlanValues = this.statusPlan.map(s => s.value);

      if (typeof data.selectTypePlan === 'string' && validPlanValues.includes(data.selectTypePlan as ViewPlans)) {
        this.selectTypePlan = data.selectTypePlan as ViewPlans;
      }

      if (Array.isArray(data.selectedCountries) && data.selectedCountries.every((v: unknown) => typeof v === 'string')) {
        this.selectedCountries = data.selectedCountries as string[];
      }

      if (Array.isArray(data.selectedCurrencies) && data.selectedCurrencies.every((v: unknown) => typeof v === 'string')) {
        this.selectedCurrencies = data.selectedCurrencies as string[];
      }

      if (Array.isArray(data.selectedPriceTypes) && data.selectedPriceTypes.every((v: unknown) => typeof v === 'string')) {
        this.selectedPriceTypes = data.selectedPriceTypes as string[];
      }

      this.products = this.enrichStatusSearchText(this.products);
      this.sanitizeFilterSelections();
    } catch {
      // Corrupted payload; discard silently
    } finally {
      try {
        localStorage.removeItem(ViewPlansComponent.STATE_STORAGE_KEY);
      } catch {
        // ignore
      }
    }
  }

}